import styled from "styled-components";

const GetQuoteButtonCss = styled.div`
    position: relative;
    margin-left: 0;    
    button{
        /* position: fixed;
        z-index: 99;
        top: 125px;
        border-radius: 0 100px 100px 0;
        background: linear-gradient(180deg, #61B01F 0%, #27911B 100%);
        color: #fff;
        border: none;
        padding: 3px 15px 3px 15px;
        font-size: 21px; */
        padding: 0;
        color: #70ac08;
        font-size: 12px !important;
        white-space: nowrap;
        font-family: 'GothamBookBold';
        border: none;
        background: none;
    }
    @media (min-width: 1441px) {
        width: fit-content;
        margin-left: calc(50vw - 726px);
    }
    @media (max-width: 767px) {
      button {
        top:88px;
      }
    }
`
const ModalBodyWrapper = styled.div`
    .modal-body{
      padding: 0 !important;
    }
    
`
const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px 10px 10px 12px;
    background: #00000005;
    align-items: end;
    .text-header{
      width: 95%;
      display: block;
    }
    h6{
      font-size: 18px;
      font-weight: bold;
    }
    p{
      font-size: 14px;
      margin: 0px;
    }
    img{
      height: 17px;
      width: 17px;
      /* margin-bottom: 2px; */
      margin-bottom: 28px;
      cursor: pointer;
    }
    
`
const ContentWrapper = styled.div`
    padding: 0px 25px 10px 25px;
    .locationState{
      input{
        background: #00000005;
      }
    }
    .app-input-text{
      margin-bottom: 0px !important;
    }
    .radio-container{
      padding-top: 2px;
    }
    .mandatorystar {
      color: #a30202;
    }
    .deliveryDateClass{
      .file-input-wrapper .MuiFormControl-root{
        height: 37px;
      }
    }
    .uploadPhoto{
      gap:0px !important;
    }
    .checkbox-field{
      margin: 10px 0;
    }
    .textAreaClass{
      .app-input-text textarea{
        height: 58px;
      }
    }
    .timmerPickerStyle{
      position: relative;
      svg{
        position: absolute;
        top: 9px;
        right: 22px;
      }
    }
    .button-style{
      display: flex;
      justify-content: center;
      margin: 25px 10px 20px 10px;
      button{
        background: linear-gradient(180deg, #61B01F 0%, #27911B 100%);
        border: none;
        border-radius: 4px;
        color: #fff;
        padding: 5px 20px 5px 20px;
      }
    }
    
`

export { GetQuoteButtonCss, ModalBodyWrapper, Header, ContentWrapper };

